module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company"
  }, [_c('banner', {
    attrs: {
      "clazz": "company-banner",
      "url": "company"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "company-content"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "content-breadcrumb cp"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_c('span', {
    on: {
      "click": _vm.GobackDetails
    }
  }, [_vm._v("公司动态和市场活动")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.breadcrumbTitle))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "content-title clearfix"
  }, [_vm._l((_vm.titleCon), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "title-one cp",
      class: {
        IsClick: _vm.clickTitle === item.id
      },
      on: {
        "click": function($event) {
          return _vm.clickType(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "popper-class": "con-popover-hot",
      "visible-arrow": false,
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.hotTags), function(item) {
    return _c('div', {
      staticClass: "cp",
      staticStyle: {
        "width": "50%",
        "float": "left"
      },
      on: {
        "click": function($event) {
          return _vm.hotClick(item.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "title-three cp",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('span', [_vm._v("热门标签")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "src": require("../../assets/img/company/companyicon2.png"),
      "alt": "热门标签"
    }
  })])]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "popper-class": "con-popover-date",
      "visible-arrow": false,
      "trigger": "click"
    }
  }, [_c('div', _vm._l((_vm.companyDate), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "cp",
      on: {
        "click": function($event) {
          return _vm.dateClick(item.dateId)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "title-two cp",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('span', [_vm._v("时间")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "src": require("../../assets/img/company/companyicon2.png"),
      "alt": "热门标签"
    }
  })])])], 1)], 2), _vm._v(" "), (_vm.checkShow) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkData),
      expression: "checkData"
    }],
    staticClass: "content-dynamic clearfix"
  }, _vm._l((_vm.newsData.news), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "dynamic-div cp db",
      attrs: {
        "href": _vm.checkDetails(item),
        "target": "_blank"
      },
      on: {
        "mouseenter": function($event) {
          return _vm.dynamicEnter(index)
        },
        "mouseleave": _vm.dynamicLeave
      }
    }, [_c('div', {
      staticClass: "dynamic-div-img",
      style: ({
        'backgroundImage': 'url(' + _vm.$global.globalPath + item.img + ')'
      })
    }, [_c('div', {
      staticClass: "dynamic-describe-show",
      class: {
        IsDescribehover: _vm.dynamicHover == index ? true : false
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.showOrigin(item.origin, index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "dynamic-div-title clearfix"
    }, [_c('h1', {
      staticClass: "dynamic-title-top"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "dynamic-title-buttom"
    }, [_c('img', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": require("../../assets/img/company/companyicon1.png"),
        "alt": item.title
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.year))])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.checkData),
      expression: "!checkData"
    }],
    staticClass: "content-nodata"
  }, [_c('span', [_vm._v("暂无数据")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkData),
      expression: "checkData"
    }],
    staticClass: "dynamic-pagination"
  }, [_c('el-pagination', {
    staticClass: "pagination-cen",
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 6,
      "current-page": _vm.currentPage,
      "pager-count": 5,
      "total": _vm.newsData.count_list
    },
    on: {
      "current-change": function($event) {
        return _vm.currentChange(_vm.currentPage)
      },
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409e243a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs/company.vue
// module id = 630
// module chunks = 12